import { axios } from '@Root/API'

export const edit = (studyProgrammeId, venueActivityId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/off-venue-activity/${venueActivityId}`, payload)
}
